import { Autocomplete, Button, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Switch, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import { CSVLink } from "react-csv";


const NetProfitSalesReport = () => {
    const classes = useStyle()
    const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [vendor , setVendor] = useState([]);
  const [catData,setCatData] = useState([])
  const [subData,setSubData] = useState([])
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1, "months").format(),
    toDate :  moment().format()
  })
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
  const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const [options, setOptions] = useState({
    customer : null,
    category : null,
    subCategory : null,
      vendor: null
})
const [reportType, setReportType] = useState("category"); 
console.log(data.length,pageCount,page,"data133446536");

function handleOptions(value, name){
    console.log(name, value)
    setPage(0);
    setOptions(prev=>({...prev,[name] : value}))
}
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
   ...(reportType === "item"
    ? [{
        field: "item_name",
        headerName: "Item Name",
        flex: 1,
        headerAlign: "center",
        align: "center",
      }]
    : []),
  {
    field: "outlet_name",
    headerName: "Outlet Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "supplier_name",
    headerName: "Supplier Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "category_name",
    headerName: "Category Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "subcategory_name",
    headerName: "Subcategory Name",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
  },
  {
  field: "total_mrp",
  headerName: "MRP Value",
  flex: 1,
  headerAlign: "center",
  align: "right",
  sortable: false,
},
  {
    field: "purchase_value_percent",
    headerName: "Purchase Value Percent ",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
  },
  {
    field: "gross_profit_percent",
    headerName: "Gross Profit Percent ",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
  },
]
console.log(data)
const rows = _.map(data,(val,idx)=>({
  id: val.id || idx + 1,
  // sno: idx+1,
   sno: page * rowsPerPage + idx + 1, 
   item_name: val.item_name,
  outlet_name : val.outlet_name,
  supplier_name: val.supplier_name,
  category_name : val.category_name,
  subcategory_name : val.subcategory_name,
  total_mrp: val.total_mrp,
  purchase_value_percent : val.purchase_value_percent,
  gross_profit_percent : val.gross_profit_percent,
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

data.forEach(val => {
  total += parseFloat(val.purchase_value_percent || 0);
});
  setTotalAmount(total.toFixed(0));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getvendorData() {
    axios
      .get("/v1/supplier")
      .then((res) => {
        console.log(res.data)
        setVendor(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getCategory(){
    axios.get('/v1/categories')
    .then(res=>{
        _.filter(res.data, val=>{
            if(val.is_active){
                 setCatData(res.data)
            }
        })
    setPageCount(res.data.length)
    console.log(res.data.length,"res.data.length");
    
    })
    .catch(err=>{
        console.log(err.response.data.error)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
function getSubCategory(){
    axios.get('/v1/subcategories')
    .then(res=>{
            setSubData(res.data)
    })
    .catch(err=>{
        console.log(err.response.data.error)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}
// function handleSalesReturn(){
//     if (!options.customer) {
//     dispatch(setSnackbar(true, "error", "Please select an outlet"));
//     return;
//   }

//   const postData = {
//     from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
//     to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
//     vendor_id: options.vendor?.id||0, 
//     outlet_id: options.customer !== null ? options.customer.id : 0,
//     main_cat_id: options.category !== null ? options.category.id : 0,
//     sub_cat_id: options.subCategory !== null ? options.subCategory.id : 0,
//     page_size: rowsPerPage,
//     current_page: page + 1
//   }

//   axios.post('/v1/reports/sales/profit', postData)
// .then(res=>{
//   setData(res.data.data || []);
//   setPageCount(Math.ceil((res.data.data?.length || 0) / rowsPerPage));
// })
//   .catch(err=>{
//     setData([])
//     dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
//   })
// }
// function handleSalesReturn(){
//   if (!options.customer) {
//     dispatch(setSnackbar(true, "error", "Please select an outlet"));
//     return;
//   }

//   const postData = {
//     from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
//     to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
//     vendor_id: options.vendor?.id||0, 
//     outlet_id: options.customer !== null ? options.customer.id : 0,
//     main_cat_id: options.category !== null ? options.category.id : 0,
//     sub_cat_id: options.subCategory !== null ? options.subCategory.id : 0,
//     page_size: rowsPerPage,
//     current_page: page + 1
//   }

//   axios.post('/v1/reports/sales/profit', postData)
//   .then(res=>{
//     // ← NEW LOGIC: Handle backend pagination structure
//     const responseData = res.data.data || res.data;
//     const meta = res.data.meta || {};
//     const pagination = meta.pagination || {};
    
//    setData(responseData || []);
// setPageCount(pagination.total || 0);
//     setPage(0);  // ← ADDED: Reset to first page
//   })
//   .catch(err=>{
//     setData([])     // ← ADDED
//     setPageCount(0); // ← ADDED
//     setPage(0);      // ← ADDED
//     dispatch(setSnackbar(true, "error", err.response?.data?.errors?.[0]?.message || "Something went wrong"));
//   })
// }
function handleSalesReturn(){
  if (!options.customer) {
    dispatch(setSnackbar(true, "error", "Please select an outlet"));
    return;
  }

  const postData = {
    from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
    vendor_id: options.vendor?.id || 0,
    outlet_id: options.customer?.id || 0,
    main_cat_id: options.category?.id || 0,
    sub_cat_id: options.subCategory?.id || 0,
    page_size: rowsPerPage,
    current_page: page + 1
  };

  // axios.post('/v1/reports/sales/profit', postData)
  const url =
  reportType === "item"
    ? "/v1/reports/sales/profit/itemwise"
    : "/v1/reports/sales/profit";

axios.post(url, postData)
  .then(res => {
    const responseData = res.data?.data || [];
    const pagination = res.data?.meta?.pagination || {};

    setData(responseData);
    setPageCount(pagination.total || 0);
  })
  .catch(err => {
    setData([]);
    setPageCount(0);
    dispatch(setSnackbar(true, "error",
      err.response?.data?.errors?.[0]?.message || "Something went wrong"
    ));
  });
}
function handleReset() {
  setOptions({
    customer: null,
    category: null,
    subCategory: null,
    vendor: null
  });

  setDateLimit({
    fromDate: moment().subtract(1, "months").format(),
    toDate: moment().format()
  });

  setReportType("category"); // reset toggle

  setPage(0);
  setData([]);
  setPageCount(0);
  setTotalAmount(0);
}
  useEffect(() => {
    getSupplierData();
    getCategory()
    getSubCategory()
    getvendorData()
  }, []);

  const generateCSVData = () => {
  const isItem = reportType === "item";

  const csvData = [
    ["From Date", moment(dateLimit.fromDate).format("YYYY-MM-DD")],
    ["To Date", moment(dateLimit.toDate).format("YYYY-MM-DD")],
    [],
    isItem
      ? ["S.no", "Item Name", "Outlet", "Supplier", "Category", "Subcategory","MRP", "Purchase %", "Profit %"]
      : ["S.no", "Outlet", "Supplier", "Category", "Subcategory", "MRP","Purchase %", "Profit %"],
  ];

  rows.forEach((row) => {
    csvData.push(
      isItem
        ? [
            row.sno,
            row.item_name,
            row.outlet_name,
            row.supplier_name,
            row.category_name,
            row.subcategory_name,
            row.total_mrp,
            row.purchase_value_percent,
            row.gross_profit_percent,
          ]
        : [
            row.sno,
            row.outlet_name,
            row.supplier_name,
            row.category_name,
            row.subcategory_name,
            row.total_mrp,
            row.purchase_value_percent,
            row.gross_profit_percent,
          ]
    );
  });

  return csvData;
};
  
  // useEffect(()=>{
  //   if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
  //     handleSalesReturn()
  //     console.log('Vanthuden')
  //   }
  // },[rowsPerPage, page, dateLimit,options])
//   useEffect(() => {
//   setPageCount(Math.ceil(data.length / rowsPerPage))
// }, [data, rowsPerPage])

useEffect(()=>{
  if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
    handleSalesReturn()
  }
},[rowsPerPage, page, dateLimit, options, reportType]) // ✅ added
  return (
  <Fragment>
    <Helmet><title>Net Profit Sales Reports</title></Helmet>
   <Typography variant="h6">Net Profit Sales Reports</Typography>
   <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[ ...supplier]}
            value={options.customer || null} 
            onChange={(e,value)=>handleOptions(value,'customer')}
            getOptionLabel={option=>option.fullname}
            isOptionEqualToValue={(option, value) =>
    option?.id === value?.id
  }
  clearOnEscape
            renderInput={(params) => <TextField {...params} label="Select Outlet *"/>}
          />
        </Grid>
         <Grid item md={3}>
                  <Autocomplete
                    size="small"
                    value={options.vendor}
                    options={vendor}
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(o, v) => o?.id === v?.id}
                    onChange={(e, value) => handleOptions(value, "vendor")}
                    renderInput={(params) => (
                      <TextField {...params} label="Supplier" />
                    )}
                  />
                </Grid>
        <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.category}
        options={catData}
        getOptionLabel={option=>option.category_name}
        onChange={(e,value)=>handleOptions(value,'category')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Category'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={subData}
        value={options.subCategory}
        getOptionLabel={option=>option.subcategory_name}
        onChange={(e,value)=>handleOptions(value,'subCategory')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Sub Category'/>
          )}
        />
      </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

<Grid item md={3}>
  <RadioGroup
    row
    value={reportType}
    onChange={(e) => setReportType(e.target.value)}
  >
    <FormControlLabel
      value="category"
      control={<Radio />}
      label="CategoryWise"
    />
    <FormControlLabel
      value="item"
      control={<Radio />}
      label="ItemWise"
    />
  </RadioGroup>
</Grid>

<Grid item md={2}>
  <Button
    variant="contained"
    color="secondary"
    fullWidth
    onClick={handleReset}
  >
    Reset
  </Button>
</Grid>
<Grid item md={2}>
  <CSVLink
    data={generateCSVData()}
    filename={
      reportType === "item"
        ? "ItemWise_Profit_Report.csv"
        : "CategoryWise_Profit_Report.csv"
    }
  >
    <Button variant="contained" fullWidth>
      Download
    </Button>
  </CSVLink>
</Grid>
      </Grid>
      <CustomTable props={props}/>
  </Fragment>
  )
}

export default memo(NetProfitSalesReport)